// Escolher as cores dos balões das Mensagens, com a prévia na hora.
import { Pressable, ScrollView, Text, View } from 'react-native';
import { setDoc } from '../store/store';
import { ENVIADA_PADRAO, OPCOES_ENVIADA, OPCOES_RECEBIDA, recebidaPadrao, useCoresChat } from '../lib/coresChat';
import { Btn, Sheet } from './ui';
import { C } from './theme';
import { t } from '../lib/i18n';

export function CoresChatSheet({ visible, onClose }: { visible: boolean; onClose: () => void }) {
  const k = useCoresChat();
  const mudar = (campo: 'enviada' | 'recebida', cor: string) => setDoc('ajustes', d => ({ ...d, chatCores: { ...(d.chatCores ?? {}), [campo]: cor || undefined } }));
  const bolinha = (cor: string, on: boolean, onPress: () => void, padrao?: boolean) => (
    <Pressable key={cor || 'padrao'} onPress={onPress} style={{ width: 46, height: 46, borderRadius: 23, backgroundColor: cor, alignItems: 'center', justifyContent: 'center',
      borderWidth: on ? 3 : 1, borderColor: on ? C.text : C.line }}>
      {on ? <Text style={{ color: '#fff', fontWeight: '900', textShadowColor: '#000', textShadowRadius: 3 }}>✓</Text> : padrao ? <Text style={{ fontSize: 10, color: C.sub }}>★</Text> : null}
    </Pressable>
  );
  const balao = (meu: boolean, texto: string) => (
    <View style={{ alignSelf: meu ? 'flex-end' : 'flex-start', maxWidth: '80%', backgroundColor: meu ? k.enviada : k.recebida, borderRadius: 16,
      borderBottomRightRadius: meu ? 4 : 16, borderBottomLeftRadius: meu ? 16 : 4, padding: 10, gap: 2 }}>
      <Text style={{ color: meu ? k.textoEnviada : k.textoRecebida, fontSize: 15 }}>{texto}</Text>
      <Text style={{ color: meu ? k.suaveEnviada : k.suaveRecebida, fontSize: 10, alignSelf: 'flex-end' }}>19:36{meu ? ' ✓' : ''}</Text>
    </View>
  );
  return (
    <Sheet visible={visible} onClose={onClose} title={t('Cores das conversas')}>
      <ScrollView contentContainerStyle={{ padding: 16, gap: 12, paddingBottom: 60 }}>
        <View style={{ backgroundColor: C.bg, borderRadius: 16, borderWidth: 1, borderColor: C.line, padding: 12, gap: 6 }}>
          {balao(false, t('Oi! Tudo certo para sábado?'))}
          {balao(true, t('Tudo! Já comprei os ingressos.'))}
          {balao(false, t('Combinado 👍'))}
        </View>
        <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700', letterSpacing: 0.8, marginTop: 6 }}>{t('O QUE VOCÊ MANDA')}</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
          {OPCOES_ENVIADA.map(c => bolinha(c, k.enviada.toLowerCase() === c.toLowerCase(), () => mudar('enviada', c === ENVIADA_PADRAO ? '' : c), c === ENVIADA_PADRAO))}
        </View>
        <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700', letterSpacing: 0.8, marginTop: 6 }}>{t('O QUE VOCÊ RECEBE')}</Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
          {OPCOES_RECEBIDA.map(c => bolinha(c || recebidaPadrao(), c ? k.recebida.toLowerCase() === c.toLowerCase() : k.recebida === recebidaPadrao(), () => mudar('recebida', c), !c))}
        </View>
        <Text style={{ color: C.mute, fontSize: 12 }}>{t('★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.')}</Text>
        <Btn outline cor={C.sub} label={t('Voltar para as cores do My Planner')} onPress={() => setDoc('ajustes', d => ({ ...d, chatCores: undefined }))} />
      </ScrollView>
    </Sheet>
  );
}
